module.exports = __webpack_public_path__ + "static/media/cross.07b71f75.svg";